import React, { Component } from 'react';
import { useTranslation } from 'react-i18next';
import { SmartphoneIcon, SearchIcon, BarChart2Icon, ArrowRightIcon, CheckCircleIcon, ShieldIcon, ZapIcon, ChevronRightIcon } from 'lucide-react';
export function AIGradingProcess() {
  const {
    t
  } = useTranslation();
  // Define fallback features in case translation fails
  const defaultFeatures = {
    scan: ['Screen damage detection', 'Body condition assessment', 'Cosmetic grading', 'Hardware verification'],
    diagnostic: ['Battery health check', 'Component functionality tests', 'IMEI verification', 'Performance analysis'],
    valuation: ['Real-time market analysis', 'Competitive pricing', 'Instant quote generation', 'Value optimization']
  };
  // Helper function to safely get features array
  const getFeatures = step => {
    try {
      const features = t(`aiGrading.steps.${step}.features`, {
        returnObjects: true
      });
      return Array.isArray(features) ? features : defaultFeatures[step];
    } catch (error) {
      return defaultFeatures[step];
    }
  };
  return <section id="ai-diagnostics" className="bg-white dark:bg-black text-gray-900 dark:text-white py-20" data-id="element-67">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-68">
        <div className="text-center mb-16" data-id="element-69">
          <div className="inline-flex items-center px-4 py-1 bg-blue-100 dark:bg-brand-green/10 text-blue-600 dark:text-brand-green rounded-full text-sm font-medium mb-4" data-id="element-70">
            <ZapIcon className="h-4 w-4 mr-2" data-id="element-71" />
            Advanced Technology
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold mb-4" data-id="element-72">
            {t('aiGrading.title')}{' '}
            <span className="text-blue-600 dark:text-brand-green" data-id="element-73">Works</span>
          </h2>
          <p className="text-gray-600 dark:text-gray-400 max-w-3xl mx-auto" data-id="element-74">
            {t('aiGrading.subtitle')}
          </p>
        </div>
        <div className="relative" data-id="element-75">
          <div className="hidden md:block absolute top-1/2 left-[33%] w-[30%] h-0.5 bg-blue-100 dark:bg-brand-green/20 transform -translate-y-1/2" data-id="element-76"></div>
          <div className="hidden md:block absolute top-1/2 right-[33%] w-[30%] h-0.5 bg-blue-100 dark:bg-brand-green/20 transform -translate-y-1/2" data-id="element-77"></div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-78">
            {[{
            step: 1,
            icon: <SmartphoneIcon className="h-12 w-12" data-id="element-79" />,
            title: t('aiGrading.steps.scan.title'),
            description: t('aiGrading.steps.scan.description'),
            features: getFeatures('scan')
          }, {
            step: 2,
            icon: <SearchIcon className="h-12 w-12" data-id="element-80" />,
            title: t('aiGrading.steps.diagnostic.title'),
            description: t('aiGrading.steps.diagnostic.description'),
            features: getFeatures('diagnostic')
          }, {
            step: 3,
            icon: <BarChart2Icon className="h-12 w-12" data-id="element-81" />,
            title: t('aiGrading.steps.valuation.title'),
            description: t('aiGrading.steps.valuation.description'),
            features: getFeatures('valuation')
          }].map((step, index) => <div key={index} className="group bg-white dark:bg-gray-900 rounded-lg p-8 relative shadow-lg border border-gray-200 dark:border-gray-800 hover:border-blue-500 dark:hover:border-brand-green/50 transition-all duration-300 hover:-translate-y-1" data-id="element-82">
                <div className="absolute -top-4 -left-4 w-12 h-12 rounded-full bg-blue-600 dark:bg-brand-green flex items-center justify-center font-bold text-xl text-white dark:text-black z-10" data-id="element-83">
                  {step.step}
                </div>
                <div className="mb-6 h-16 flex items-center justify-center text-blue-600 dark:text-brand-green group-hover:scale-110 transition-transform" data-id="element-84">
                  {step.icon}
                </div>
                <h3 className="text-xl font-bold mb-4 text-center text-gray-900 dark:text-white" data-id="element-85">
                  {step.title}
                </h3>
                <p className="text-gray-600 dark:text-gray-400 text-center mb-6" data-id="element-86">
                  {step.description}
                </p>
                <div className="mt-6 pt-6 border-t border-gray-200 dark:border-gray-800" data-id="element-87">
                  <ul className="space-y-3" data-id="element-88">
                    {step.features.map((feature, featureIndex) => <li key={featureIndex} className="flex items-center text-gray-700 dark:text-gray-300 group-hover:text-gray-900 dark:group-hover:text-white transition-colors" data-id="element-89">
                        <CheckCircleIcon className="h-5 w-5 text-blue-600 dark:text-brand-green mr-3 flex-shrink-0" data-id="element-90" />
                        <span data-id="element-91">{feature}</span>
                      </li>)}
                  </ul>
                </div>
              </div>)}
          </div>
        </div>
        <div className="mt-16 text-center" data-id="element-92">
          <a href="#demo" className="inline-flex items-center px-6 py-3 bg-blue-600 dark:bg-brand-green text-white dark:text-black rounded-full hover:bg-blue-700 dark:hover:bg-brand-green/90 transition-all transform hover:scale-105 font-medium group" data-id="element-93">
            See DiagnostiX in Action
            <ArrowRightIcon className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" data-id="element-94" />
          </a>
        </div>
      </div>
    </section>;
}